/* eslint-disable @typescript-eslint/no-explicit-any */
import { buildScene7WideVerUrl } from './scene7WideVerUrl';

function pickImagePath(image: { assetPath?: string; renditionUrl?: string | null } | undefined): string | undefined {
  const fromAsset = image?.assetPath?.trim();
  if (fromAsset) return fromAsset;
  const fromRendition = image?.renditionUrl?.trim();
  if (fromRendition) return fromRendition;
  return undefined;
}

/**
 * Scene7 preview URL with `:Wide-Ver` from an AEM `aImage`-shaped field (`{ image: { assetPath, … } }`).
 * Call with o-results `aImage` or o-chat `aImage2` depending on the component.
 */
export function resolveChatPreviewImageUrl(aImageField?: any): string | null {
  return buildScene7WideVerUrl(pickImagePath(aImageField?.image));
}
